import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.div`
  padding: 20px;
  display: flex;
  height: calc(100vh - 372px);
  justify-content: center;
`;

const Card = styled.div`
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  padding: 20px;
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
`;

const StyledLink = styled(Link)`
  color: black;
  text-decoration: none;
  margin-bottom: 10px;
  padding: 20px;
  background-color: rgb(245, 245, 245);
  border-radius: 10px;
`;

const Home = () => {
  return (
    <Container>
      <Card>
        <StyledLink to="/hivex-data-management-and-policy/">
          hivex-data-management-and-policy
        </StyledLink>
        <StyledLink to="/hivex_issuer_customersupport/PP">
          hivex_issuer_customersupport/PP
        </StyledLink>
        <StyledLink to="/hivex-uptime">hivex-uptime</StyledLink>
      </Card>
    </Container>
  );
};
export default Home;
